/* @flow */

import {
    type VoucherVisibilidade,
    type VoucherCondicao,
    type VoucherTipo,
} from './types';

export const isPrivado = (visibilidade: VoucherVisibilidade) => visibilidade === 'privado';
export const isPublico = (visibilidade: VoucherVisibilidade) => visibilidade === 'publico';
export const isUsoUnico = (condicao: VoucherCondicao) => condicao === 'uso_unico';
export const isPrimeiraCompra = (condicao: VoucherCondicao) => condicao === 'primeira_compra';
export const isPorcentagem = (tipo: VoucherTipo) => tipo === '%';
export const isValor = (tipo: VoucherTipo) => tipo === 'R$';
